module.exports = __webpack_public_path__ + "static/media/home_main_bg.d2221fc3.png";